import $ from 'jquery';
import Api from '../util/Api';

$('body').on('click', '.catalog-detail-gallery__item--preview', function () {
    $('.catalog-detail-gallery__item--big').css('background-image', $(this).css('background-image'));
});

$('.catalog-detail-subscribe__form').submit(function (e) {
    e.preventDefault();
    const params = {};
    $(this).serializeArray().forEach((param) => {
        params[param.name] = param.value;
    });
    Api.post('/api/subscription/product/?clear_cache=Y', params)
        .then(() => {
            $('.catalog-detail-subscribe__footer').addClass('hidden');
            $('.catalog-detail-subscribe__success').removeClass('hidden');
        });
});
